import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  Grid,
  CircularProgress,
  Box,
  TableHead,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import { GetReport, GetReportsList } from 'src/components/services/httpServices';

import { Download } from 'react-feather';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ReportListPage(props) {
  let { id, checkClient } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [reportsList, setReportsList] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const fetchCompany = async (event) => {
    const reports = await GetReportsList();
    setReportsList(reports);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const getReport = async (fileName) => {
    setLoading(true);
    var payload = {
      reportName: fileName,
      params: [{ parameter: 'param', value: id }],
    };
    // console.log(payload);

    let response = await GetReport(id, payload);
    // console.log('PostResponse:', response);

    if (response?.status == 200) {
      const url = window.URL.createObjectURL(response?.data);
      // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      // link.setAttribute('download', report+'.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
      props.setMessage('Success');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      //   console.log('500');
      props.setMessage(response?.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      setPosting(false);
    }
  };
  //  console.log('reportsList:', reportsList);
  return (
    <>
      <Helmet>
        <title> Reports | Immigration System </title>
      </Helmet>
      <Container>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Forms
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
       
          </Stack>
        </Stack> */}
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={3}
            component={Paper}
            boxShadow={3}
            marginBottom={4}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <br></br>
                <br></br>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr#</TableCell>
                        <TableCell>Report Name</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reportsList?.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row}</TableCell>
                          <TableCell>
                            <IconButton onClick={() => getReport(row)} aria-label="delete" size="small">
                              <Download />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow key={9}>
                        <TableCell>{9}</TableCell>
                        <TableCell>Employee Agreement</TableCell>
                        <TableCell>
                          <IconButton aria-label="delete" size="small">
                            <Download />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow key={10}>
                        <TableCell>{10}</TableCell>
                        <TableCell>Leave Request Form</TableCell>
                        <TableCell>
                          <IconButton aria-label="delete" size="small">
                            <Download />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow key={11}>
                        <TableCell>{11}</TableCell>
                        <TableCell>New Retainer Agreement</TableCell>
                        <TableCell>
                          <IconButton aria-label="delete" size="small">
                            <Download />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow key={12}>
                        <TableCell>{12}</TableCell>
                        <TableCell>Staff Agreement - Final</TableCell>
                        <TableCell>
                          <IconButton aria-label="delete" size="small">
                            <Download />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow key={13}>
                        <TableCell>{13}</TableCell>
                        <TableCell>CANDIDATE AGREEMENT</TableCell>
                        <TableCell>
                          <IconButton aria-label="delete" size="small">
                            <Download />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
